module.exports = __webpack_public_path__ + "img/login-bg-top.ede6cc1b.png";